/** Host Google Calendar integration page. */
export const HOST_GOOGLE_CALENDAR_HREF = '/host/google-calendar';

/**
 * Integrations nav + `/host/google-calendar` + org settings “Manage” link.
 * Central place for connect / disconnect / link rooms & tutors.
 */
export const GOOGLE_CALENDAR_UI_ENABLED = true;

/**
 * Inline Google Calendar dropdowns on room create/details and tutor profile.
 * Keep false so linking stays only on `/host/google-calendar`.
 */
export const GOOGLE_CALENDAR_INLINE_PICKERS_ENABLED = false;

/**
 * @deprecated Prefer HOST_GOOGLE_CALENDAR_HREF. Kept so older deep-links and copy still resolve.
 * Formerly pointed at `/host/organization#google-calendar`.
 */
export const ORGANIZATION_GOOGLE_CALENDAR_SECTION_ID = 'google-calendar';

export const ORGANIZATION_GOOGLE_CALENDAR_HREF = HOST_GOOGLE_CALENDAR_HREF;
